import http from '@/shared/api/http'

export async function getAllCategories() {
  return (await http.get('categories')).data
}

export async function getCategoryById(categoryId) {
  return (await http.get(`categories/${categoryId}`)).data
}

export async function createCategory(payload) {
  return (await http.post('categories', payload)).data
}

export async function updateCategory(categoryId, payload) {
  return (await http.put(`categories/${categoryId}`, payload)).data
}

export async function deleteCategory(categoryId) {
  return (await http.delete(`categories/${categoryId}`)).data
}